// NO EDITAR A MANO
// const id = "footer.link_apps.url-windows";
const valor = `https://www.microsoft.com/store/apps/9wzdncrdk0j6`;

export default valor;
